// Service catalogue. Copy carried over verbatim from the v1 site so nothing
// written for New Age Services is lost in the redesign.

export const communicationSolutions = [
  {
    title: "PRI",
    description:
      "A robust telephony solution designed to handle large volumes of incoming and outgoing calls.",
    image: "/PRI.jpg",
  },
  {
    title: "SIP Trunk",
    description:
      "VoIP-based phone services that replace traditional telephony lines, offering cost-efficiency and flexibility.",
    image: "/SIP Trunk.png",
  },
  {
    title: "Toll-Free",
    description:
      "Provide businesses with toll-free calling options, enhancing customer accessibility and service.",
    image: "/TollFree.jpg",
  },
  {
    title: "Video Conferencing",
    description:
      "High-quality virtual meeting solutions to connect teams, clients, and partners, fostering collaboration in a remote world.",
    image: "/VideoConference.jpg",
  },
];

export const connectivitySolutions = [
  {
    title: "Broadband",
    description:
      "High-speed internet connectivity with flexible bandwidth options to meet diverse business needs.",
    image: "/Broadband.jpg",
  },
  {
    title: "Internet Leased Line",
    description:
      "A dedicated, high-speed internet connection that offers reliable and consistent performance.",
    image: "/Internet Leased Line.jpg",
  },
  {
    title: "MPLS",
    description:
      "Secure and efficient data transfer across multiple locations, ensuring optimal network performance.",
    image: "/MPLS.jpg",
  },
  {
    title: "SD-WAN",
    description:
      "A software-based solution that optimizes wide-area network performance through intelligent routing.",
    image: "/SD-WAN.jpg",
  },
];

export const securitySolutions = [
  {
    title: "Antivirus Solutions",
    description:
      "Robust protection against malware, viruses, and other security threats.",
    image: "/Antivirus.jpg",
  },
  {
    title: "Firewall",
    description:
      "Advanced firewall solutions to monitor and protect your network from unauthorized access.",
    image: "/firewall.jpg",
  },
  {
    title: "Surveillance",
    description:
      "Integrated physical security systems to monitor and protect your premises.",
    image: "/Surveillance.jpg",
  },
  {
    title: "Biometrics",
    description:
      "Cutting-edge biometric security solutions for secure access control and authentication.",
    image: "/Biometrics.jpg",
  },
  {
    title: "VDI",
    description:
      "VDI enables secure access to enterprise systems from any device without the need for company-provided hardware.",
    image: "/VDI.jpg",
  },
];

export const allSolutions = [
  ...communicationSolutions,
  ...connectivitySolutions,
  ...securitySolutions,
];

export const modalDetails = {
  PRI: {
    extraInfo:
      "PRI (Primary Rate Interface) provides dedicated voice channels for businesses. It enables seamless and high-quality voice communication over ISDN lines.",
    features: [
      "Up to 30 voice channels per connection",
      "Clear, reliable call quality",
      "Supports both incoming and outgoing calls",
    ],
    useCases: ["Call centers", "Enterprises with high call volume", "Banks and financial services"],
    benefits: ["High call capacity", "Improved voice clarity", "Secure and reliable communication"],
  },
  "SIP Trunk": {
    extraInfo:
      "SIP Trunking replaces traditional telephone lines using the internet, reducing costs while improving flexibility and scalability.",
    features: [
      "Scalable VoIP-based communication",
      "Seamless integration with PBX systems",
      "Cost-effective international calling",
    ],
    useCases: ["Remote teams", "Multi-location businesses", "Cost-conscious enterprises"],
    benefits: [
      "Reduced telephony costs",
      "Flexible call routing",
      "Supports remote and hybrid workforces",
    ],
  },
  "Toll-Free": {
    extraInfo:
      "Toll-free numbers allow customers to reach businesses without incurring call charges, enhancing accessibility and service quality.",
    features: ["Nationwide accessibility", "Easy-to-remember numbers", "Supports IVR and call forwarding"],
    useCases: ["Customer support centers", "Helplines and emergency services", "E-commerce businesses"],
    benefits: ["Better customer engagement", "Enhanced brand credibility", "Increased lead generation"],
  },
  "Video Conferencing": {
    extraInfo:
      "Video conferencing tools provide HD video and audio solutions for virtual meetings, enabling real-time collaboration.",
    features: ["HD video and audio clarity", "Screen sharing and chat options", "Multi-device compatibility"],
    useCases: ["Remote work", "Client meetings", "Online training and webinars"],
    benefits: [
      "Reduced travel costs",
      "Improved team collaboration",
      "Enhanced communication efficiency",
    ],
  },
  Broadband: {
    extraInfo:
      "Broadband provides high-speed internet connectivity with flexible plans tailored for businesses of all sizes.",
    features: ["High-speed data transmission", "Various bandwidth options", "Reliable and stable connection"],
    useCases: ["Small and medium businesses", "Retail outlets and offices", "Remote work setups"],
    benefits: [
      "Affordable and flexible plans",
      "Quick deployment and easy setup",
      "Consistent and uninterrupted connectivity",
    ],
  },
  "Internet Leased Line": {
    extraInfo:
      "A dedicated internet connection that ensures stable and high-speed network performance for business-critical applications.",
    features: ["Dedicated bandwidth", "Symmetrical upload/download speeds", "24/7 monitoring and support"],
    useCases: [
      "Large enterprises requiring constant uptime",
      "Data centers and cloud applications",
      "Businesses with high data transfer needs",
    ],
    benefits: [
      "Uninterrupted, reliable connectivity",
      "Secure and private data transmission",
      "Improved business efficiency",
    ],
  },
  MPLS: {
    extraInfo:
      "MPLS is a secure, high-performance networking solution designed for businesses with multiple locations.",
    features: [
      "Fast and secure data transfer",
      "Low latency and packet loss",
      "Prioritized traffic for critical applications",
    ],
    useCases: ["Multi-branch companies", "Financial institutions", "Healthcare networks"],
    benefits: [
      "Improved network efficiency",
      "Seamless site-to-site connectivity",
      "Reduced downtime and better security",
    ],
  },
  "SD-WAN": {
    extraInfo:
      "SD-WAN optimizes network performance using intelligent routing to enhance business connectivity.",
    features: [
      "Centralized network control",
      "Real-time traffic optimization",
      "Secure connectivity across multiple locations",
    ],
    useCases: ["Enterprises with remote branches", "Cloud-based businesses", "IT-driven industries"],
    benefits: [
      "Cost-effective compared to MPLS",
      "Better application performance",
      "Enhanced security and scalability",
    ],
  },
  "Antivirus Solutions": {
    extraInfo:
      "Comprehensive cybersecurity software to safeguard devices from viruses, malware, and cyber threats.",
    features: [
      "Real-time threat detection",
      "Automatic updates for latest threats",
      "Multi-device protection",
    ],
    useCases: [
      "Businesses handling sensitive data",
      "Individuals needing robust cybersecurity",
      "IT environments requiring endpoint security",
    ],
    benefits: [
      "Prevents cyberattacks and data breaches",
      "Enhances system performance and stability",
      "Protects business continuity",
    ],
  },
  Firewall: {
    extraInfo:
      "A security system that monitors and controls incoming and outgoing network traffic based on predefined security rules.",
    features: [
      "Intrusion prevention system (IPS)",
      "Deep packet inspection",
      "VPN support for secure remote access",
    ],
    useCases: [
      "Enterprises requiring secure network access",
      "Data centers and cloud environments",
      "Financial and government institutions",
    ],
    benefits: [
      "Strong defense against cyber threats",
      "Secure and controlled data access",
      "Reduces risk of unauthorized access",
    ],
  },
  Surveillance: {
    extraInfo:
      "A security solution that integrates CCTV and advanced monitoring systems to protect businesses and properties.",
    features: ["High-resolution video recording", "Motion detection and alerts", "Cloud storage and remote access"],
    useCases: ["Retail stores and shopping malls", "Office spaces and warehouses", "Smart homes and gated communities"],
    benefits: [
      "Enhanced security and monitoring",
      "Deters theft and unauthorized access",
      "Remote access for real-time surveillance",
    ],
  },
  Biometrics: {
    extraInfo:
      "Advanced biometric security systems using fingerprints, facial recognition, and iris scanning for secure authentication.",
    features: [
      "Contactless and secure authentication",
      "Fast and accurate identification",
      "Integration with access control systems",
    ],
    useCases: [
      "Corporate offices and government agencies",
      "High-security zones and research facilities",
      "Time and attendance tracking systems",
    ],
    benefits: [
      "Eliminates unauthorized access",
      "Reduces identity fraud risks",
      "Enhances overall security efficiency",
    ],
  },
  VDI: {
    extraInfo:
      "Virtual Desktop Infrastructure (VDI) is an IT framework that enables users to access enterprise computer systems from virtually any device—such as personal computers, phones, or tablets—without the company needing to provide or maintain physical hardware. VDI hosts desktop environments on a centralized server, running operating systems within virtual machines and delivering them to end users over a network. Supported end-user devices include PCs, tablets, and thin clients.",
    features: [
      "Remote access to enterprise desktops",
      "Centralized management and security",
      "Device-independent computing experience",
    ],
    useCases: [
      "Remote workforces and BYOD environments",
      "Educational institutions for virtual labs",
      "Call centers and technical support desks",
    ],
    benefits: [
      "Reduces hardware costs and maintenance",
      "Improves data security and compliance",
      "Enables flexible and scalable IT operations",
    ],
  },
};
